export const getQvctSurveyReport = (state) => state.qvctSurveysReport
